import { CatalogApp } from '@/webapi/use-widget-catalog-api';
import { Experience } from '@/webapi/use-experience-api';
import { maybe } from '@/features/details/utils';
import { Opt } from '@/features/details/date-pick/quick-range-select';

export enum Pages {
  HOME = `/`,
  DASHBOARD = `/dashboard`,
  EDITOR = `/editor`,
  EXPERIENCE_DETAILS = `/details`,
  LOGIN = `/login/`,
  PLEASE_REINSTALL = `/please-reinstall`,
  SIGN_UP = `/signup`,
  WELCOME = `/welcome`,
  AWAIT_EMAIL = `/await-email`,
  ACCOUNT_SETTINGS = `/account-settings`,
  SHOP_SETTINGS = `/shop-settings`,
  TEAMMATES = `/teammates`,
  AISETTINGS = `/ai-settings`,
  ACCOUNTS = `/accounts`,
  THEMES = `/themes`,
  INTEGRATIONS = `/integrations`,
  AI_PLAYGROUND = `/73095e64-cfd3-465a-b627-2cef2f199f0d/ai-playground`,
  GLOBAL_RULES = `/global-rules`,
  COPILOT_STARTERS = `/copilot-starters`,
}

export function editorRoute(expId?: string) {
  if (expId) {
    return `${Pages.EDITOR}?expId=${expId}`;
  }
  return `${Pages.EDITOR}`;
}

export function editorRouteWithWidget(app: CatalogApp) {
  return `${Pages.EDITOR}?app=${app.id}`;
}

export function editorRouteWithAudience(audienceId: string) {
  return `${Pages.EDITOR}?audience=${audienceId}`;
}

export function detailsRoute(exp: Experience, audience = ``) {
  function formatDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, `0`);
    const day = String(date.getDate()).padStart(2, `0`);
    return `${year}-${month}-${day}`;
  }
  const startDate = maybe(() => formatDate(new Date(exp.metricsStartAt)));
  let route = `${Pages.EXPERIENCE_DETAILS}?expId=${exp.id}`;

  if (startDate) {
    route = `${route}&s=${startDate}`;
  }
  if (exp.sessionType) {
    route = `${route}&st=${exp.sessionType}`;
  }
  if (exp.smoothRevenueEnabled) {
    route = `${route}&outlier=1`;
  }
  if (exp.otwForAllVariants) {
    route = `${route}&otw4all=1`;
  }
  if (audience) {
    route = `${route}&aud=${audience}&o=${Opt.LastMonth}&e=${formatDate(
      new Date(),
    )}`;
  }
  return route;
}
